import type { FaireProductEntity } from "../../entity_types/product";

export const p_7nywyfddpf: FaireProductEntity = {
  token: "p_7nywyfddpf",
  type: "product",
  name: "Mali Hoops - Hazel",
  brandToken: "b_8c38xgktp7",
  brandName: "NAT + NOOR",
  imageUrl:
    "https://cdn.faire.com/fastly/d82bd2d78ab2fe5f06d620f9de5f8a4d802496c0c47eb03ee3c0f2cdf1679e56.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c665e52ea2daabbae9a22939d03c1b9f375b4711c78b45f2419bcb512bc08f4d.jpeg",
  ],
  priceDollars: 11,
  description:
    "DIAMETER - .6” (small size) COLOR - Hazel tortoise brown MATERIALS - Hypoallergenic stainless steel posts - cellulose acetate - a renewable material / resource essentially made from wood pulp QUALITIES - eco-friendly & sustainable hoop earrings - minimalist hoop earrings Nat + Noor is all about quality over quantity. We make things the right way. They cost more to produce and they cost more to purchase. If you want a product that was made with intentionality, durability and a love for good design, our products are for you. \nFunctionally elevated & aesthetically compelling ~ designed by Natalia Riboldi Seasonal Searches: Wedding Gifts, Mother’s Day Gifts, Valentine’s Day Gifts, Housewarming Gifts, Holiday Gift Ideas, Bridal Shower Gifts, Christmas Gifts, Year-Round Gifting, Summer, 4th of July, winter Accessories, Stocking Fillers, Boutique Gift Ideas",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:41.579Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
